export default __webpack_public_path__ + "cea270acdaf3ab2fd1243e3843f18a8a.gif";